import React, { useState } from 'react';

import { defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import CommonInput from '../Inputs/Common';

const messages = defineMessages({
	title: {
		id: 'orgHeaderItens.title',
		defaultMessage: 'Alternar entre contas'
	},
	inputPlaceholder: {
		id: 'orgHeaderItens.inputPlaceholder',
		defaultMessage: 'Pesquisar Contas'
	}
});

const OrganizationsHeaderItens = ({ intl, onSearch }) => {
	const { formatMessage } = intl;
	const [searchValue, setSearchValue] = useState('');

	const handleChange = ({ target: { value } }) => {
		setSearchValue(value);
		onSearch(value);
	};

	return (
		<article className="OrganizationMenu__pane">
			<div className="OrganizationMenu__container mb-4 mt-2">
				<h3 data-test="component-organization-header-title" className="title is-2 has-text-white">
					{formatMessage(messages.title)}
				</h3>
				<CommonInput
					placeholder={formatMessage(messages.inputPlaceholder)}
					onChange={handleChange}
					value={searchValue}
					loading={false}
					icon="fa-sharp fa-regular fa-magnifying-glass"
					data-test="component-organization-header-input"
				/>
			</div>
		</article>
	);
};

OrganizationsHeaderItens.propTypes = {
	intl: PropTypes.shape({
		formatMessage: PropTypes.func
	}).isRequired,
	onSearch: PropTypes.func.isRequired
};


export default OrganizationsHeaderItens;
